import RedeemDetails from './RedeemDetails';

export default RedeemDetails;
